import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { JobService } from 'src/app/core/services/job.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';

declare var $: any;
declare var bootbox: any;

@Component({
  selector: 'app-upload-resumes',
  templateUrl: './upload-resumes.component.html'
})
export class UploadResumesComponent implements OnInit, AfterViewInit {

  @ViewChild(DropzoneDirective) resumeUploadDropzoneDirective: DropzoneDirective;

  @Input() jobId;
  @Input() candidateId;
  @Input() controlObject: any;
  @Input() sourceScreen;
  @Input() formalizeActivityPayload;
  @Input() initialSourceTypeId: string;
  @Input() initialUploadDate: Date;
  @Output() cancelCallback = new EventEmitter<void>();
  @Output() candidateProcessedCallback = new EventEmitter<void>();
  @Output() completeCallback = new EventEmitter<void>();

  MESSAGECONSTANTS = MESSAGECONSTANTS;

  defaultJobSourceTypeId: any;
  sourceTypeList: any[] = [];
  resumeList: any[] = [];
  sourceType: any = null;
  sourceTypeId: any = null;
  otherSourceTypeNotes: any = null;
  referrerName: any = null;
  referrerEmail: any = null;
  uploadResumesResponse: any = null;
  totalUploads: any = null;
  candidatesList: any[] = [];
  candidatesToAssociateList: any[] = [];
  candidateCount: any = null;
  createJobMatchesObject: any = null;
  addedFilesInDropzone: any[] = [];
  maxResumesToUpload = 40;
  uploadDate: any = null;
  displayUploadDate: any = null;

  isSingleCandidateUpload = false;
  disableUploadButtonFlag = true;
  fileExistsFlag = false;
  disableCancelButtonFlag = false;
  fileUploadInProgressFlag = false;
  disableSourceTypesFlag = false;
  resumeScoringDoneFlag = false;
  scoringCandidatesFlag = false;
  jobContextExistsFlag = false;
  isUploadResumeWarningModalOpen = false;

  resumeUploadDropzone: any;
  dropzoneConfig: DropzoneConfigInterface;

  constructor(
    private authService: AuthService,
    private angularModalService: AngularModalService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private resumeService: ResumeService,
    private jobService: JobService,
    private dateTimeUtilityService: DateTimeUtilityService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe
  ) { }

  ngOnInit() {
    this.initVariables();

    if (this.candidateId) {
      this.isSingleCandidateUpload = true;
    }
    if (this.jobId !== null && this.jobId !== undefined && this.jobId != '') {
      this.jobContextExistsFlag = true;
      this.createJobMatchesObject = {
        companyId: this.authService.userDetails.company.companyId,
        requisitionId: this.jobId,
        candidateIds: [],
        manuallyMatchedFromUI: true,
        transactionId: null,
        isAssociateCandidate: false,
        overrideNoteDetails: []
      };
    }
    this.resumeList = [];
    this.getAllSourceTypes(() => {
      this._applyInitialSourceType();
      if (this.jobId !== null && this.jobId !== undefined && this.jobId != '') {
        this.getLastAddedCandidateSourceTypeId();
      }
    });
    this.dropzoneConfig = this._getDropZoneSettings();

    this._initializeUploadDatePicker();
  }

  ngAfterViewInit() {
    this.resumeUploadDropzone = this.resumeUploadDropzoneDirective.dropzone();
  }

  initVariables() {
    this.sourceTypeList = [];
    this.resumeList = [];
    this.sourceType = null;
    this.sourceTypeId = null;
    this.otherSourceTypeNotes = null;
    this.referrerName = null;
    this.referrerEmail = null;
    this.uploadResumesResponse = null;
    this.totalUploads = null;
    this.candidatesList = [];
    this.candidatesToAssociateList = [];
    this.candidateCount = null;
    this.createJobMatchesObject = null;
    this.addedFilesInDropzone = [];
    this.maxResumesToUpload = 40;
    this.uploadDate = null;
    this.displayUploadDate = null;
    this.isSingleCandidateUpload = false;
    this.disableUploadButtonFlag = true;
    this.fileExistsFlag = false;
    this.disableCancelButtonFlag = false;
    this.fileUploadInProgressFlag = false;
    this.disableSourceTypesFlag = false;
    this.resumeScoringDoneFlag = false;
    this.scoringCandidatesFlag = false;
    this.jobContextExistsFlag = false;
    this.isUploadResumeWarningModalOpen = false;
  }

  getLastAddedCandidateSourceTypeId() {
    this.jobService.getLastAddedCandidateSourceTypeId(this.jobId, (data) => {
      this.defaultJobSourceTypeId = data.lastAddedCandidateSourceTypeId;
      this._setDefaultSourceType();
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  onFileAdded(file) {
    this.fileExistsFlag = true;
    this.updateActionButtons();
    $('.dz-progress').css({ top: '70%' });
    this.addedFilesInDropzone.push(file);
    if (!this.isUploadResumeWarningModalOpen) {
      if (this.addedFilesInDropzone.length > this.maxResumesToUpload) {
        this.isUploadResumeWarningModalOpen = true;
        const title = 'Max Limit Exceeded';
        const message = `There is a maximum limit of <b>${this.maxResumesToUpload}</b> resumes that can be uploaded at once.
                  <br>You have currently exceeded this limit.
                  <br>We will reduce the number of files currently being uploaded to ${this.maxResumesToUpload}.
                  <br>The last file in this list is <b>${this.addedFilesInDropzone[this.maxResumesToUpload - 1]['name']}</b>`;
        this.alertsAndNotificationsService.showAlertWithCallBack(title, message, 'warning', () => {
          this.isUploadResumeWarningModalOpen = false;
          this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          setTimeout(() => {
          }, 200);
        });
      }
    }
  }

  onMaxFilesExceeded(file) {
    this.resumeUploadDropzone.removeFile(file);
  }

  onFileRemoved(file) {
    this.addedFilesInDropzone = this.addedFilesInDropzone.filter(resume => resume.upload.uuid !== file.upload.uuid);
    if (this.resumeUploadDropzone.files.length === 0) {
      this.disableUploadButtonFlag = true;
    }
  }

  onFileSendingMultiple(args) {
    const formData = args[2];
    this.disableUploadButtonFlag = true;
    this.disableSourceTypesFlag = true;
    this.fileUploadInProgressFlag = true;
    const resumeUpload: any = {};
    resumeUpload.companyId = this.authService.userDetails.company.companyId;
    resumeUpload.userId = this.authService.userDetails.id;
    resumeUpload.resumeSourceTypeId = this.sourceTypeId;
    resumeUpload.buIdList = [];
    formData.append('companyId', resumeUpload.companyId);
    formData.append('resumeSourceTypeId', resumeUpload.resumeSourceTypeId);
    formData.append('userId', resumeUpload.userId);
    formData.append('buIdList', resumeUpload.buIdList);
    if (this.sourceType.sourceType == 'Other') {
      formData.append('otherSourceTypeNotes', this.otherSourceTypeNotes);
    } else {
      formData.append('otherSourceTypeNotes', null);
    }
    if (this.sourceType.sourceType == 'Referral') {
      formData.append('referrerName', this.referrerName);
      formData.append('referrerEmail', this.referrerEmail);
    } else {
      formData.append('referrerName', null);
      formData.append('referrerEmail', null);
    }
    if (this.jobContextExistsFlag) {
      formData.append('jobId', this.jobId);
    }
    if (this.uploadDate) {
      formData.append('uploadDateAndTime', this.uploadDate);
    }
  }

  onFileSuccessMultiple(args) {
    const response = args[1];
    this.fileUploadInProgressFlag = false;
    this.disableUploadButtonFlag = true;
    this.alertsAndNotificationsService.showBannerMessage(response.message, 'success');
    if (this.candidateProcessedCallback) {
      this.candidateProcessedCallback.emit();
    } else if (this.completeCallback) {
      this.completeCallback.emit();
    }
    $('.dz-hidden-input').prop('disabled', true);
    $('.dz-remove').hide();
  }

  onFileError(args) {
    const file = args[0];
    const error = args[1];
    const elements = document.querySelectorAll('.dz-file-preview');
    elements.forEach((element: any) => {
      const filename = element.querySelectorAll('.dz-filename span')[0].textContent;
      const errorMessage = element.querySelectorAll('.dz-error-message span')[0];
      if (filename === file.name) {
        errorMessage.textContent = error.message == undefined ? error : error.message;
      }
    });
  }

  _getDropZoneSettings(): DropzoneConfigInterface {
    let maxFilesToUpload = this.maxResumesToUpload;
    if (this.isSingleCandidateUpload) {
      maxFilesToUpload = 1;
    }
    const dropZoneSettings: any = {
      url: this.resumeService.getUploadUrl() + '/async',
      paramName: () => 'file',
      acceptedFiles: '.pdf,.xlsx,.docx,.doc',
      maxFiles: maxFilesToUpload,
      maxFilesize: 10,
      maxThumbnailFilesize: 10,
      timeout: 300000,
      addRemoveLinks: true,
      autoProcessQueue: false,
      uploadMultiple: true,
      parallelUploads: 100
    };
    if (this.jobContextExistsFlag) {
      dropZoneSettings.url = dropZoneSettings.url + '?jobId=' + this.jobId;
    }
    return dropZoneSettings;
  }

  cancelUploadResumes() {
    let message = 'Are you sure you want to cancel ?';
    let showPopUp = true;
    let createCandidatesFlag = false;
    if (this.resumeScoringDoneFlag) {
      // do nothing.
    } else {
      if (this.resumeList.length) {
        message = 'No job matches will be created for the uploaded candidate(s).<br>Do you still want to continue?';
        createCandidatesFlag = true;
      } else if (this.resumeUploadDropzone.files.length > 0) {
        message = 'Are you sure you want to cancel ?<br>Un-uploaded files exist in the upload area.';
      } else {
        showPopUp = false;
      }
    }
    if (showPopUp) {
      bootbox.confirm({
        closeButton: false,
        title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
        message,
        className: 'zIndex1060',
        backdrop: true,
        onEscape: false,
        buttons: {
          confirm: {
            label: 'Yes',
            className: 'btn-info'
          },
          cancel: {
            label: 'Cancel',
            className: 'btn-danger'
          }
        },
        callback: (result) => {
          const dialogMessage = "<p class='text-center'>Creating candidate(s) for uploaded resume(s) <i class='fa fa-spinner fa-spin'></i><br>Please go to Candidates screen to view the candidate(s).</p>";
          if (result) {
            if (createCandidatesFlag) {
              const createUploadedCandidatesDialog = bootbox.dialog({
                message: dialogMessage,
                closeButton: false
              });
              this.resumeService.runResumesWithoutScoring(this.uploadResumesResponse, this.jobId, () => {
                createUploadedCandidatesDialog.modal('hide');
                this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                if (this.cancelCallback) {
                  this.cancelCallback.emit();
                }
              }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
              });
            } else {
              if (this.cancelCallback) {
                this.cancelCallback.emit();
              }
            }
          } else {
            this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          }
        }
      });
    } else {
      if (this.cancelCallback) {
        this.cancelCallback.emit();
      }
    }
  }

  updateActionButtons() {
    if (this.resumeList.length > 0) {
      this.disableSourceTypesFlag = true;
      this.resumeUploadDropzone.clickable = false;
      this.disableUploadButtonFlag = true;
    } else {
      if (this.fileExistsFlag) {
        if (!_.isNull(this.sourceTypeId)) {
          this.disableUploadButtonFlag = false;
        } else {
          this.disableUploadButtonFlag = true;
        }
      } else {
        this.disableUploadButtonFlag = true;
        this.disableSourceTypesFlag = false;
      }
    }
  }

  getAllSourceTypes(successCallback) {
    this.resumeService.getAllSourceTypes((data) => {
      this.sourceTypeList = data;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }

  private _applyInitialSourceType() {
    const match = this.sourceTypeList.find((sourceType) => sourceType.id === this.initialSourceTypeId);
    if (match) {
      this.sourceType = match;
      this.sourceTypeChanged();
    }
  }

  private _setDefaultSourceType() {
    if (this.initialSourceTypeId) {
      return;
    }
    if (this.defaultJobSourceTypeId !== undefined && this.defaultJobSourceTypeId !== '' && !_.isNull(this.defaultJobSourceTypeId)) {
      const index = this.sourceTypeList.findIndex((sourceType) => sourceType.id == this.defaultJobSourceTypeId);
      if (index !== -1) {
        this.sourceType = this.sourceTypeList[index];
        this.sourceTypeId = this.sourceType.id;
      }
    }
  }

  sourceTypeChanged() {
    if (this.sourceType !== undefined && this.sourceType !== null && this.sourceType.id !== undefined) {
      this.sourceTypeId = this.sourceType.id;
      this.updateActionButtons();
    } else {
      this.sourceTypeId = null;
    }
  }

  uploadResumes(uploadResumesForm) {
    if (uploadResumesForm.valid) {
      this.resumeUploadDropzone.processQueue();
    }
  }

  openUploadDatePicker() {
    $('#displayUploadDate').datepicker('show');
  }

  private _initializeUploadDatePicker() {
    const today = new Date();
    const todayStr = today.toDateString();

    $('#displayUploadDate').datepicker({
      format: 'M d, yyyy',
      endDate: today,
      weekStart: 1,
      autoclose: true
    });

    $('#displayUploadDate').datepicker('setDate', today);

    this.displayUploadDate = this.fourDotFiveDateFormatPipe.transform(today);
    $('#displayUploadDate').datepicker('update', this.displayUploadDate);

    this.uploadDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(today);

    $('#displayUploadDate').datepicker().on('changeDate', (e) => {
      const selectedDate = new Date(e.date);
      const selectedStr = selectedDate.toDateString();

      this.displayUploadDate = this.fourDotFiveDateFormatPipe.transform(selectedDate);

      if (selectedStr === todayStr) {
        this.uploadDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date());
      } else {
        selectedDate.setHours(23, 59, 59, 999);
        this.uploadDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(selectedDate);
      }
    });

    if (this.initialUploadDate) {
      $('#displayUploadDate').datepicker('setDate', this.initialUploadDate);
    }
  }

  receiveFormalizedComment(event) {
    this.otherSourceTypeNotes = event;
  }

  onVoiceTranscript(transcript) {
    if (this.otherSourceTypeNotes) {
      this.otherSourceTypeNotes += ' ' + transcript;
    } else {
      this.otherSourceTypeNotes = transcript;
    }
  }
}
